import { Component, effect, Signal, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AssetDeletedEvent, TreeEventsConsumerService } from '@assethub/shared/services';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { Toast, ToastModule } from 'primeng/toast';
import { CalloutComponent } from '../callout/callout.component';
import { AdministratorsModalComponent } from '../modals/administrators-modal/administrators-modal.component';

@Component({
  selector: 'app-asset-deleted-toast',
  templateUrl: './asset-deleted-toast.component.html',
  styleUrls: ['./asset-deleted-toast.component.scss'],
  imports: [ToastModule, CalloutComponent, TranslateModule, RouterLink],
})
export class AssetDeletedToastComponent {
  readonly key = 'assetDeletedToast';
  @ViewChild('toast') private toast: Toast | undefined;

  private assetDeleted: Signal<AssetDeletedEvent | undefined>;

  constructor(
    treeEventsConsumerService: TreeEventsConsumerService,
    private messageService: MessageService,
  ) {
    this.assetDeleted = treeEventsConsumerService.assetDeleted;
    effect(() => {
      const event = this.assetDeleted();
      if (!event) {
        return;
      }
      this.onAssetDeletedEvent(event);
    });
  }

  public onClose(message: ToastMessageOptions) {
    if (this.toast?.messages && this.toast.messages.length > 0) {
      const messageIndex = this.toast.messages.findIndex(entry => entry.id === message.id);
      if (messageIndex !== -1) {
        this.toast.messages?.splice(messageIndex, 1);
      }
    }
  }

  onAssetDeletedEvent(event: AssetDeletedEvent) {
    const canRestore = event.asset.root.administrable;
    this.messageService.add({
      key: this.key,
      data: { uuid: event.asset.uuid, canRestore, movedToTrash: event.movedToTrash },
      sticky: false,
      life: 60000,
      closable: false,
    });
  }

  showAdmins(event: Event, uuid: string): void {
    event.preventDefault();
    AdministratorsModalComponent.open(uuid, 'permission-insights.restore');
  }
}
